// Added by Sejune Oh on 2019-09-04
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { HTTP_HEADER_AUTH_KEY } from '@/helper/define'
import Logger from '@/helper/Logger'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export interface StreamOnProcess {
    (result: ResServerStatusProps): void
}
export interface StreamOnCompleteFuncProps {
    (result: any): void
}
export interface StreamOnErrorFuncProps {
    (err: any): void
}
export interface ResServerStatusProps {
    result?: {
        system_status?: {
            aview_server_connection?: ServerConnectionProps
            new_version?: VersionInfoProps
        }
    }
    err?: any
}

export interface ServerConnectionProps {
    name?: string
    endpoint?: string
    connected?: boolean
}
export interface VersionInfoProps {
    has_new_version?: boolean
    version?: string
    filepath?: string
}

type ReqGetServerEventStream = {
    onProessResponse: StreamOnProcess
    onConnected: Function
    onComplete: StreamOnCompleteFuncProps
    onError: StreamOnErrorFuncProps
    bindSignOutFunction: Function
    bindDestroyFunction: Function
    signal: AbortSignal
}

export const reqGetServerEventStream = ({
    onProessResponse,
    onConnected,
    onComplete,
    onError,
    bindSignOutFunction,
    bindDestroyFunction,
    signal
}: ReqGetServerEventStream) => {
    const url = `${axios.defaults.baseURL}/v1/mgmt/server-event`
    const authToken = axios.defaults.headers.common[HTTP_HEADER_AUTH_KEY]
    fetch(url, {
        headers: {
            [HTTP_HEADER_AUTH_KEY]: authToken,
        },
        signal
    })
        .then((response: Response) => {
            const reader = response!.body!.getReader()
            const decoder = new TextDecoder()
            onConnected()
            bindSignOutFunction(reader)
            bindDestroyFunction(reader)

            return readChunk()

            function readChunk(): any {
                return reader.read().then(({ value, done }) => {
                    const chunk = decoder.decode(value || new Uint8Array(), { stream: !done })
                    const message = JSON.parse(chunk)

                    Logger.devLog('[Server Status] Get stream data from server')
                    onProessResponse(message)

                    if (done) return
                    return readChunk()
                })
            }
        })
        .then(onComplete)
        .catch((err) => {
            /** AbortController에 의해 Abort된 경우 (Signout 처리) Error 아님 */
            if (!signal.aborted) onError(err)
        })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ReqUpdateToNewVersionProps { }
export const reqUpdateToNewVersion = async () => {
    return await axios.post<ReqUpdateToNewVersionProps>(`v1/mgmt/server-command/install-new-version`, {})
}
